module.exports = __webpack_public_path__ + "img/4_4_1.a80cad85.jpg";